import React from "react";
import { CloseCircleFilled } from "Common/ReactIcons";
import "./CustomDrawer.scss";

const CustomDrawer = ({
  visible,
  title,
  placement,
  onClose,
  children,
  height,
  width,
}) => {
  const drawerClass = `custom-drawer ${visible ? "visible" : ""} ${placement}`;

  return (
    <div>
      <div className={drawerClass} style={{ height, width }}>
        <div className="drawer-header">
          {title && <div className="drawer-title">{title}</div>}
          {/* <button onClick={onClose} className="close-button">
            &times;
          </button> */}
          <CloseCircleFilled onClick={onClose} style={{cursor:"pointer"}}/>
        </div>
        <div className="drawer-content">{children}</div>
      </div>
      {visible && <div className="drawer-overlay" onClick={onClose} />}
    </div>
  );
};

CustomDrawer.defaultProps = {
  placement: "bottom",
  height: "300px",
  width: "100%",
};

export default CustomDrawer;
